import { abbreviate, Avatar, Flex, Text } from '@revolut-internal/ui-kit'
import { FC } from 'react'

type DialogueAvatarProps = {
  authorName?: string | null
  isAgentMessage?: boolean
  dateTime: string
}

export const DialogueAvatar: FC<DialogueAvatarProps> = props => {
  const { isAgentMessage = false, authorName, dateTime } = props

  if (!authorName && !dateTime) {
    return null
  }

  return (
    <Flex
      mt="s-2"
      justifyContent="flex-end"
      alignItems="center"
      flexDirection={isAgentMessage ? undefined : 'row-reverse'}
    >
      <Text
        variant="small"
        color="grey-tone-50"
        textAlign="center"
        pr={isAgentMessage ? 's-8' : undefined}
        pl={isAgentMessage ? undefined : 's-8'}
      >
        {dateTime}
      </Text>
      {authorName ? (
        <Avatar
          label={authorName === 'new_rita' ? undefined : abbreviate(authorName)}
          size={32}
          useIcon={authorName === 'new_rita' ? 'LogoRevolut' : undefined}
        />
      ) : null}
    </Flex>
  )
}
